import './supDropdown.css';
import { useEffect, useState } from 'react';
import ReactLoading from 'react-loading';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import EmptyPage from '../../components/empty-page/emptyPage';
import Pagination from '../../components/pagination/Pagination';
import {
    deleteDropdown,
    dropdownCount,
    editDropdownSubmit,
    fetchDropdowns,
    filterCount
} from './dropdownFun/dropdownCRUD';
import Dialog from '../../components/dialogModal/dialogModal';

const DropdownList = () => {
    const navigate = useNavigate();
    const { type } = useParams();
    const [searchParams, setSearchParams] = useSearchParams();
    const [loading, setLoading] = useState(false);
    const [dropDownData, setDropDownData] = useState([]);
    const [offSet, setOffSet] = useState(0);
    const [pageNumber, setPageNumber] = useState(1);
    const selectedType = searchParams.get('type') || 'trip';
    const selectedFilter = type;
    const [deleteModal, setDeleteModal] = useState(false);
    const [changeStatusModal, setChangeStatusModal] = useState(false);
    const [rowClickId, setRowClickId] = useState(0);
    const [rowData, setRowData] = useState({});
    const [load, setLoad] = useState(false);
    const status = searchParams.get('status') || 'active';
    const [totalCount, setTotalCount] = useState(0);
    const limit = 10;
    const { mode } = useParams();

    const refresh = () => {
        setLoad(!load);
    };

    const totalData = totalCount;
    const tableHeader = ['Type', 'Heading', 'Names', 'Action'];

    useEffect(() => {
        if (!selectedType) return;
        const fetchDropdownData = async () => {
            fetchDropdowns(setDropDownData, setLoading, offSet, limit, selectedType, selectedFilter, status);
        };
        fetchDropdownData();
        //eslint-disable-next-line
    }, [selectedType, load, selectedFilter, status]);

    useEffect(() => {
        if (selectedFilter === 'dropdown') {
            dropdownCount(setTotalCount, selectedType, setLoading);
        } else {
            filterCount(setTotalCount, setLoading);
        }
        //eslint-disable-next-line
    }, [selectedType, selectedFilter]);

    const getDropdownName = (dropdown) => {
        const dropdownName = dropdown.map((item) => {
            return item?.displayName ?? 'N/A';
        });
        return dropdownName.join(', ');
    };

    const paginationClick = (number, offSetNumber) => {
        if (Math.ceil(totalData / limit) > 1) {
            setPageNumber(+number);
            setOffSet(+offSetNumber);
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        }
    };

    const handleDelete = () => {
        deleteDropdown(rowClickId, setLoading, setDeleteModal, refresh, selectedFilter);
    };

    const handleChangeStatus = async () => {
        const data = {
            ...rowData,
            status: rowData.status === 'active' ? 'deactive' : 'active'
        };
        const res = await editDropdownSubmit(rowData._id, data, setLoading, selectedFilter);
        if (res === 200) {
            setChangeStatusModal(false);
            refresh();
        }
    };
    const handleUpdateParams = (e) => {
        const { name, value } = e.target;

        setSearchParams((prevParams) => {
            const newParams = new URLSearchParams(prevParams);
            newParams.set(name, value);
            return newParams;
        });
    };

    return (
        <>
            {loading && (
                <div className='loadingBackground'>
                    <ReactLoading type='spin' color='#006aff' className='loadingSpin' />
                </div>
            )}
            <div className='supFilter'>
                <h1 className='supportHeader'>Dropdowns/Filters</h1>
                <div>
                    <select
                        name='type'
                        id='type'
                        className='select'
                        value={selectedFilter}
                        onChange={(e) => {
                            navigate(`/support/admin/${e.target.value}`);
                        }}
                        style={{ marginRight: '8px' }}
                    >
                        <option value='dropdown'>Dropdown</option>
                        <option value='filter'>Filter</option>
                    </select>
                    <select
                        name='status'
                        id='status'
                        className='select'
                        value={status}
                        onChange={(e) => handleUpdateParams(e)}
                        style={{ marginRight: '8px' }}
                    >
                        <option value='active'>Active</option>
                        <option value='in-active'>Expired</option>
                    </select>
                    <select
                        name='type'
                        id='type'
                        className='select'
                        value={selectedType}
                        onChange={(e) => handleUpdateParams(e)}
                        style={{ marginRight: '8px' }}
                    >
                        <option value='trip'>Trip</option>
                        <option value='camp'>Camp</option>
                        <option value='guide'>Guide</option>
                        <option value='activity'>Activity</option>
                    </select>
                    <button
                        onClick={() =>
                            navigate(`/support/${mode}/${selectedFilter}/upload`, {
                                state: { filter: selectedFilter }
                            })
                        }
                        className='addDropdownBtn blueBtn'
                    >
                        {selectedFilter === 'dropdown' ? 'Add Dropdown' : 'Add Filter'}
                    </button>
                </div>
            </div>
            <div className='supDropdwonContainer'>
                {dropDownData?.length === 0 && !loading ? (
                    <EmptyPage />
                ) : (
                    <div className='tableContainer'>
                        <table className='table'>
                            <thead className='tableHead'>
                                <tr>
                                    {tableHeader.map((head, headIndex) => {
                                        return <th key={headIndex}>{head}</th>;
                                    })}
                                </tr>
                            </thead>
                            <tbody>
                                {dropDownData?.map((row, rowIndex) => {
                                    return (
                                        <tr key={rowIndex} className='tableBodyRow'>
                                            <td>{row?.type ?? 'N/A'}</td>
                                            <td>{row?.heading ?? 'N/A'}</td>
                                            <td className='ellipsisCell ellipsisCellLarge'>
                                                {getDropdownName(row.dropdown)}
                                            </td>
                                            <td>
                                                <button
                                                    className='actBtn payoutBtn noWidth'
                                                    onClick={() =>
                                                        navigate(`/support/${mode}/dropdowns/upload`, {
                                                            state: {
                                                                row,
                                                                filter: selectedFilter
                                                            }
                                                        })
                                                    }
                                                >
                                                    Edit
                                                </button>
                                                <button
                                                    className={`actBtn ${
                                                        row.status === 'active' ? 'billBtn' : 'payoutBtn'
                                                    } noWidth`}
                                                    style={{
                                                        marginRight: '4px'
                                                    }}
                                                    onClick={() => {
                                                        setRowData(row);
                                                        setChangeStatusModal(true);
                                                    }}
                                                >
                                                    {row.status === 'active' ? 'Deactivate' : 'Activate'}
                                                </button>
                                                <button
                                                    className='actBtn billBtn noWidth'
                                                    onClick={() => {
                                                        setRowClickId(row._id);
                                                        setDeleteModal(true);
                                                    }}
                                                >
                                                    Delete
                                                </button>
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                        <div className='responsiveCardContainer'>
                            {dropDownData?.map((row, rowIndex) => (
                                <div key={rowIndex} className='responsiveCard'>
                                    <div className='cardContent'>
                                        <p>
                                            <strong>{tableHeader[0]}:</strong> {row?.type ?? 'N/A'}
                                        </p>
                                        <p className='bookingCardLabelDisplay'>
                                            <strong>{tableHeader[1]}:</strong> {row?.heading ?? 'N/A'}
                                        </p>
                                        <p>
                                            <strong>{tableHeader[2]}:</strong> {getDropdownName(row.dropdown)}
                                        </p>
                                        <div className='sendMessageBtn'>
                                            <button
                                                className='actBtn payoutBtn noWidth'
                                                onClick={() =>
                                                    navigate(`/support/${mode}/dropdowns/upload`, {
                                                        state: {
                                                            row,
                                                            filter: selectedFilter
                                                        }
                                                    })
                                                }
                                            >
                                                Edit
                                            </button>
                                            <button
                                                className={`actBtn ${
                                                    row.status === 'active' ? 'billBtn' : 'payoutBtn'
                                                } noWidth`}
                                                style={{ marginRight: '4px' }}
                                                onClick={() => {
                                                    setRowData(row);
                                                    setChangeStatusModal(true);
                                                }}
                                            >
                                                {row.status === 'active' ? 'Deactivate' : 'Activate'}
                                            </button>
                                            <button
                                                className='actBtn billBtn noWidth'
                                                onClick={() => {
                                                    setRowClickId(row._id);
                                                    setDeleteModal(true);
                                                }}
                                            >
                                                Delete
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                )}
                <Pagination
                    paginationClick={paginationClick}
                    numberOfRows={totalData}
                    offSet={offSet}
                    pageNumber={pageNumber}
                    limit={limit}
                />
                {deleteModal && (
                    <Dialog openModal={deleteModal} heading={'Delete Confirmation!'}>
                        <div className='dialogContent'>
                            <p className='confirmationText'>Are you sure?</p>
                            <p className='confirmationMessage'>You want to delete this data.</p>
                            <div className='alignCenter'>
                                <button className='dialogActBtn submit' onClick={handleDelete}>
                                    Yes
                                </button>
                                <button
                                    className='dialogActBtn cancel'
                                    onClick={() => {
                                        setDeleteModal(false);
                                        setRowClickId(0);
                                    }}
                                >
                                    No
                                </button>
                            </div>
                        </div>
                    </Dialog>
                )}
                {changeStatusModal && (
                    <Dialog
                        openModal={changeStatusModal}
                        heading={`${rowData.status === 'active' ? 'Deactivate' : 'Activate'} Confirmation!`}
                    >
                        <div className='dialogContent'>
                            <p className='confirmationText'>Are you sure?</p>
                            <p className='confirmationMessage'>
                                {`You want to ${rowData.status === 'active' ? 'Deactivate' : 'Activate'} this data.`}
                            </p>
                            <div className='alignCenter'>
                                <button className='dialogActBtn submit' onClick={handleChangeStatus}>
                                    Yes
                                </button>
                                <button
                                    className='dialogActBtn cancel'
                                    onClick={() => {
                                        setChangeStatusModal(false);
                                        setRowData({});
                                    }}
                                >
                                    No
                                </button>
                            </div>
                        </div>
                    </Dialog>
                )}
            </div>
        </>
    );
};

export default DropdownList;
